module.exports = __webpack_public_path__ + "static/media/icon_orden_ascendente.df6c84b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_orden_ascendente.svg
// module id = 338
// module chunks = 0